import { loadYoutubeApi } from '../../js/helper';

window.initSupportContent = ($content) => {
    const $productSupportTeaserSliders = $content.querySelectorAll('[data-productsupportteaserslider="slider"]');
    if ($productSupportTeaserSliders.length > 0) {
        import('../../modules/product-support/product-support-teaser-slider').then(({ ProductSupportTeaserSlider }) => {
            for (let i = 0; i < $productSupportTeaserSliders.length; i++) {
                const $productSupportTeaserSlider = $productSupportTeaserSliders[i];

                const productSupportTeaserSliderAPI = new ProductSupportTeaserSlider($productSupportTeaserSlider, {
                    resizeHandler: window.resizeHandler
                });

                $productSupportTeaserSlider.API = productSupportTeaserSliderAPI;
            }
        });
    }

    // const $productSupportFilters = $content.querySelectorAll('[data-productsupport-filter="root"]');
    // if ($productSupportFilters.length > 0) {
    //     import('./modules/product-support/filter').then(({ Filter }) => {
    //         for (let i = 0; i < $productSupportFilters.length; i++) {
    //             const $productSupportFilter = $productSupportFilters[i];
    //
    //             const productSupportFilterAPI = new Filter($productSupportFilter, {
    //                 loader: window.OPTIONS.loader,
    //                 onShowDetails: ($details) => {
    //                     window.initSupportContent($details);
    //                     window.scrolling = true;
    //                 },
    //                 onSubmitted: ($result) => {
    //                     window.initSupportContent($result);
    //                 }
    //             });
    //             $productSupportFilter.API = productSupportFilterAPI;
    //         }
    //     });
    // }

    const $contentVideos = $content.querySelectorAll('[data-contentvideo="root"]');
    const $howToVideos = $content.querySelectorAll('[data-howtovideos="root"]');

    if ($contentVideos.length > 0 || $howToVideos.length > 0) {
        loadYoutubeApi();

        window.onYouTubeIframeAPIReady = () => {
            if ($contentVideos.length > 0) {
                import('../../modules/content-video/content-video').then(({ ContentVideo }) => {
                    for (let i = 0; i < $contentVideos.length; i++) {
                        const contentVideoAPI = new ContentVideo($contentVideos[i]);
                        $contentVideos[i].API = contentVideoAPI;
                    }
                });
            }
            if ($howToVideos.length > 0) {
                import('../../modules/how-to-videos/how-to-videos').then(({ HowToVideos }) => {
                    for (let i = 0; i < $howToVideos.length; i++) {
                        const howToVideosAPI = new HowToVideos($howToVideos[i], {
                            loader: window.OPTIONS.loader,
                            resizeHandler: window.resizeHandler
                        });
                        howToVideosAPI.API = howToVideosAPI;
                    }
                });
            }
        };
    }

    const $dtswissIdForms = $content.querySelectorAll('[data-idform="root"]');
    if ($dtswissIdForms.length > 0) {
        import('../../modules/product-support/idform').then(({ IdForm }) => {
            for (let i = 0; i < $dtswissIdForms.length; i++) {
                const $dtswissIdForm = $dtswissIdForms[i];

                const dtswissIdFormAPI = new IdForm($dtswissIdForm, {
                    loader: window.OPTIONS.loader
                });
                $dtswissIdForm.API = dtswissIdFormAPI;
            }
        });
    }

    const $dtswissMaterialnumberForms = $content.querySelectorAll('[data-materialnumberform="root"]');
    if ($dtswissMaterialnumberForms.length > 0) {
        import('../../modules/product-support/materialnumberform').then(({ Materialnumberform }) => {
            for (let i = 0; i < $dtswissMaterialnumberForms.length; i++) {
                const $dtswissMaterialnumberForm = $dtswissMaterialnumberForms[i];

                const dtswissMaterialnumberFormAPI = new Materialnumberform($dtswissMaterialnumberForm, {
                    loader: window.OPTIONS.loader
                });
                $dtswissMaterialnumberForm.API = dtswissMaterialnumberFormAPI;
            }
        });
    }

    const $productSupportResult = $content.querySelector('[data-product-support-result="root"]');
    if ($productSupportResult) {
        import('../../modules/product-support/product-support-result/product-support-result').then(({ ProductSupportResult }) => {
            const productSupportResult = new ProductSupportResult($productSupportResult, {
                initContent: window.initSupportContent,
                resizeHandler: window.resizeHandler
            });
            productSupportResult.init();
        });
    }

    const $productSupportTabs = $content.querySelectorAll('[data-product-support-tabs="root"]');
    if ($productSupportTabs.length > 0) {
        import('../../modules/product-support/product-support-tabs').then(({ ProductSupportTabs }) => {
            for (let i = 0; i < $productSupportTabs.length; i++) {
                const $productSupportTabsItem = $productSupportTabs[i];

                const productSupportTabsAPI = new ProductSupportTabs($productSupportTabsItem, {
                    loader: window.OPTIONS.loader,
                    resizeHandler: window.resizeHandler
                });

                $productSupportTabsItem.API = productSupportTabsAPI;
            }
        });
    }

    const $productSupportOverview = $content.querySelectorAll('.product-support-overview-teaser');
    if ($productSupportOverview.length > 0) {
        import('../../modules/product-support/product-support-overview').then(({ ProductSupportOverview }) => {
            for (let i = 0; i < $productSupportOverview.length; i++) {
                const $productSupportOverviewItem = $productSupportOverview[i];

                const productSupportOverviewAPI = new ProductSupportOverview($productSupportOverviewItem);

                $productSupportOverviewItem.API = productSupportOverviewAPI;
            }
        });
    }

    const $productSupportOverlayOpenLinks = $content.querySelectorAll('[data-product-support-overlay="open"]');
    if ($productSupportOverlayOpenLinks.length > 0) {
        import('../../modules/product-support/product-support-overlay').then(({ ProductSupportOverlay }) => {
            for (let i = 0; i < $productSupportOverlayOpenLinks.length; i++) {
                const $openLink = $productSupportOverlayOpenLinks[i];
                const openLinkAPI = new ProductSupportOverlay($openLink, {
                    loader: window.OPTIONS.loader
                });
                $openLink.API = openLinkAPI;
            }
        });
    }

    const $$productSupportTeaser = $content.querySelectorAll('[data-product-support-teaser="root"]');
    for (let i = 0; i < $$productSupportTeaser.length; i++) {
        import('../../modules/product-support/product-support').then(({ ProductSupport }) => {
            const $productSupportTeaser = $$productSupportTeaser[i];
            const productSupport = new ProductSupport($productSupportTeaser, {
                loader: window.OPTIONS.loader,
                initContent: window.initSupportContent
            });
            productSupport.init();
        });
    }

    const $glossaries = $content.querySelectorAll('[data-glossary]');
    if ($glossaries.length > 0) {
        import('../../components/glossary/glossary').then(({ Glossary }) => {
            for (let i = 0; i < $glossaries.length; i++) {
                const $glossary = $glossaries[i];

                const glossaryAPI = new Glossary($glossary, {
                    loader: window.OPTIONS.loader
                });
                $glossary.API = glossaryAPI;
            }
        });
    }

    const $accordions = $content.querySelectorAll('[data-accordion]');

    if ($accordions.length > 0) {
        import('../../components/accordion/accordion').then(({ Accordion }) => {
            for (let i = 0; i < $accordions.length; i++) {
                const $accordion = new Accordion($accordions[i]);
                $accordion.initialize();
            }
        });
    }
};

window.addEventListener('content.loaded', (e) => {
    window.initSupportContent(document.querySelector('body'));
});
